import React from 'react';
import Slider, { Settings } from 'react-slick';
import * as Styled from './BannerCarousel.styles';

type BannerSlide = {
  image: string;
  href?: string;
};

type BannerCarouselProps = {
  slides: BannerSlide[];
  interval?: number;
};

const BannerCarousel: React.FC<BannerCarouselProps> = ({
  slides,
  interval = 5000,
}) => {
  if (!slides.length) return null;

  const settings: Settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: slides.length > 1,
    autoplaySpeed: interval,
    pauseOnHover: false,
    cssEase: 'ease',
  };

  return (
    <Styled.Carousel>
      <Slider {...settings}>
        {slides.map((slide) =>
          slide.href ? (
            <Styled.SlideLink
              key={slide.image}
              href={slide.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={slide.image} alt="banner" />
            </Styled.SlideLink>
          ) : (
            <Styled.Slide key={slide.image}>
              <img src={slide.image} alt="banner" />
            </Styled.Slide>
          )
        )}
      </Slider>
    </Styled.Carousel>
  );
};

export default BannerCarousel;
